import React, {useState} from 'react';
import {connect} from "react-redux";
import ErrorBoundary from '../../common/ErrorBoundary';
import Col from "@prism/col";
import Thumbnail from "../../photoPanelContent/Thumbnail";
import Row from "@prism/row";
import DamageImageModal from "./DamageImageModal";
import {getActiveImage} from "../../../actions/damageImageActions";

const DamageImages = (props) => {

    const [modalOpen, setModalOpen] = useState(false);
    const [displayImage, setDisplayImage] = useState({});

    const onImageClick = (image) => {
        setDisplayImage(image);
        toggleModal();
    };

    const toggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    const compileDamageImages = () => {
        const {damages, damageImages} = props;
        let images = [];
        damages?.forEach(damage => {
            let damageImage = damageImages.find(damageImage => {
                if (damageImage.status === 'DELETED') return false;
                return damageImage.key === damage.damageId;
            });

            damageImage && images.push({
                category: "DMG",
                src: {
                    thumbnail: damageImage.url,
                    lowRes: damageImage.url
                },
                description: damage.item,
                damageKey: damage.damageKey,
                damageId: damage.damageId,
                imageTag: damageImage.angle,
                damage: damage
            })
        });
        return images;
    };

    let damageImagesWithDamageKey = compileDamageImages()
    if (!damageImagesWithDamageKey?.length) {
        return <>
            <div id='damage-images-container' className="container">
                <Row>
                    <div style={{height: '200px'}} className="col-md-6 offset-md-3 text-center">
                        <div className={`imageviewer-photo-not-available`}>
                            <div className={'icon-wrapper'}><i className={'icon prism-icon-image'}/></div>
                            <div><span>Media Not Available</span></div>
                        </div>
                    </div>
                </Row>
            </div>
        </>;
    } else {
        return (
            <div id='damage-images-container' className={"container"}>
                <ErrorBoundary>
                    <DamageImageModal
                        showModal={modalOpen}
                        toggle={toggleModal}
                        imageTitle={displayImage.description}
                        damageKey={displayImage.damageKey}
                        damageId={displayImage.damageId}
                        damage={displayImage.damage || {}}
                        getActiveImage={props.getActiveImage}
                        conditionType={props.conditionType}
                    />

                    <Row className="mb-3">
                        {damageImagesWithDamageKey.map(image => {
                            return <Col xs={6} className="p-1">
                                <Thumbnail
                                    image={image}
                                    imageKey={image.description}
                                    onClick={() => onImageClick(image)}
                                />
                            </Col>;
                        })}
                    </Row>
                </ErrorBoundary>
            </div>
        )
    }
}

const matchDispatchToProps = {
    getActiveImage
};

function mapStateToProps({condition, damageImages, userDetails}) {
    const {damages, conditionType} = condition;
    return {damageImages, damages, conditionType, userDetails};
}

export default connect(mapStateToProps, matchDispatchToProps)(DamageImages);